module.exports = __webpack_public_path__ + "img/even_icon_white.a661bd6f.svg";